import React from 'react';
import { Search } from 'assets/icons';

interface Props {
	label?: string,
	name: string,
	type?: string 
	color?: string,
	placeholder?: string,
	onChange: any,
	value?: string | number
}

const onChange = (event: any,_onChange: (event: any) => void,type: string = 'text') => {
	if (type == 'number') {
		const regex = /^[0-9\b]+$/;
		if (regex.test(event.target.value) || event.target.value == '') {
			_onChange(event);
		}
	}
	else if (type == 'decimal') {
		const regex = /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/
		if (regex.test(event.target.value) || event.target.value == '') {
			_onChange(event);
		}
	}
	else {
		_onChange(event);
	}
}

const Input	= React.forwardRef((props: any, ref) => (
	<div className="form-group form-group-input" style={props.containerStyle}>
		{ props.label && <label htmlFor={ props.name }>{ props.label }</label> }
		<input 
			ref={ ref }
			{ ...props }
			onChange={ (e) => onChange(e,props.onChange,props.type) }
			type={ props.type == 'number' ? 'text' : props.type }
			className={ `form-control ${ props.color ? 'input-'+props.color : 'input-white' } ${props.className ? props.className : ""}` }
			name={ props.name } />
		{
			props.searchRight && (
				<img className="image-search-input" src={ Search } />
			)
		}
	</div>
))

export default Input;